import React, { useEffect, useState, useRef,useContext } from "react";
import { useParams } from "react-router-dom";
import Container from "react-bootstrap/Container";
import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import VariationModal from "../../Components/Modals/variation_modal";
import { BrowserView, MobileView } from "react-device-detect";
import Header from "../../Components/Header";
import Footer from "../../Components/Footer";
import { ApiService } from "../../Components/Services/apiservices";
import InfiniteScroll from "react-infinite-scroll-component";
import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";
import constant from "../../Components/Services/constant";
import { ToastContainer, toast } from "react-toastify";
import Productlistsidebar from "../../Components/Elements/product_list_sidebar";
import MobileHeader from "../../Components/Elements/mobile_header";
import QuickViewModal from "../../Components/Modals/quick_view_modal";
import sessionCartData from "../../Components/Elements/cart_session_data";
import StarRating from "../../Components/Elements/starrating";
import Modal from "react-bootstrap/Modal";
import multiCurrency from "../../Components/Elements/multi_currrency";
import { Helmet } from "react-helmet";
import DataContext from "../../Components/Elements/eventContext";
import ProductCarasoulSchema from "./ProductCarasoulSchema";


function Productlist({ onParentData }) {
  const didMountRef = useRef(true);
  const dataArray = sessionCartData();
  const parsedCartSession = dataArray[1];
  const [cartCount, setCartCount] = useState(parsedCartSession.length);
  const [resProductsData, setProductsData] = useState([]);
  const [currentNumber, setCurrentNumber] = useState(1);
  const [LastNumber, setLastNumber] = useState(100);
  const [loadingMore, setLoadingMore] = useState(false);
  const [loading, setLoading] = useState();
  const [sorting, setSorting] = useState("");
  const [totalLength, setTotalLength] = useState("");
  const { slug } = useParams();
  const [setSession, SetSession] = useState("");
  const [productData, setProductData] = useState(null);
  const [showQuick, setShowQuick] = useState(false);
  const [show, setShow] = useState(false);
  const [showSort, setShowSort] = useState(false);
  const [showFilter, setShowFilter] = useState(false);
  const [pageData, setPageData] = useState("")
  const [sortingSession, setSortingSession] = useState("")
  const [filterData, setFilterData] = useState()
  const contextValues = useContext(DataContext) 
  const loginModal = () => {
    contextValues.setToggleLoginModal(!contextValues.toggleLoginModal)
  }
  const handleShow = () => setShow(true);
  const handleChildData = (status) => {
    setShow(status);
  };
  const handleShowSortModal = () => {
    setShowSort(true);
  };
  const handleShowFilterModal = () => {
    setShowFilter(true);
  };
  const handleShowQuickModal = (data) => {
    setProductData(data);
    setShowQuick(true);
  };
  const handleChildQuickModalData = (status) => {
    setShowQuick(status);
  };
  useEffect(() => {
    setLoading(true);
    if (didMountRef.current) {
      setFilterData(JSON.parse(localStorage.getItem('FILTER_SESSION')))
      SetSession(localStorage.getItem("USER_TOKEN"));
      const getPageData = {
        slug: "shop",
      };
      ApiService.postData("page-content", getPageData).then((res) => {
        if (res.status == "success") {
          setPageData(res.data)
        } else {
        }
      });
      getfilterproducts(null)
    }
    didMountRef.current = false;
  }, []);
  const [showVariation, setShowVariation] = useState(false);
   
  const handleChildVariationModalData = (status) => {
    const dataArray = sessionCartData();
    const parsedCartSession = dataArray[1];
    setCartCount(parsedCartSession.length)
    setShowVariation(status);

  };
  const addtofav = (productId) => {
    const dataString = {
      product_id: productId,
    };
    ApiService.postData("add-to-fav", dataString).then((res) => {
      if (res.data.status == "success") {
        var element = document.getElementById("wishlisticon" + productId);
        element.classList.remove("d-icon-heart", "d-icon-heart-full");
        element.classList.add(res.data.notification);
        if (res.data.notification == "d-icon-heart") {
          toast.success("Removed from wishlist");
        } else {
          toast.success("Added to Wishlist");
        }
      }
    });

  }; 

  const handleFilteredData = (data) => {
    setProductsData(data);
  };  
  const handlecatName = (data) => {
  };
  const handlecatImage = (categoryData) => {
  };
  const setscrolldata = (scroll) => {
  };

  const handleClosesort = () => {
    // Logic to close the modal
    setShowSort(false);
  };
  const handleChildFilterModalData = (status) => {
    setShowFilter(status);
  }; 

  const removefilterdata = (key, value) => {
    const array = JSON.parse(localStorage.getItem('FILTER_SESSION'));
    const newArray = array[key].filter(item => item !== value);
    array[key] = newArray

    localStorage.setItem('FILTER_SESSION', JSON.stringify(array));
    window.location.reload()
  }

  const resetFilter = () => {
    localStorage.removeItem('FILTER_SESSION')
    localStorage.removeItem('SORT_SESSION')
    localStorage.removeItem('RANGE_SESSION')
    window.location.reload()
  }

  const getfilterproducts = (sort = null) => {
    if (loadingMore) return; 
    setLoadingMore(true);
    let currentPage = currentNumber;
    if (sort != null) {
      localStorage.setItem('SORT_SESSION', sort);
      currentPage = 1;
      setCurrentNumber(2); 
      setLastNumber(1);
    }
 
    let sortsession = ""
    if (localStorage.getItem('SORT_SESSION') && localStorage.getItem('SORT_SESSION') !== null) {
      sortsession = localStorage.getItem('SORT_SESSION');
      setSortingSession(localStorage.getItem('SORT_SESSION'))
    }
    let pageNumber = Math.ceil(resProductsData.length / 12) + 1;

    const dataString = {
      filterArray: JSON.parse(localStorage.getItem('FILTER_SESSION')),
      sort: sortsession ? sortsession : "",
      priceRange: JSON.parse(localStorage.getItem('RANGE_SESSION'))
    };
    // if(localStorage.getItem('FILTER_SESSION') !== null ){
if(currentPage <= LastNumber || sort != null){
  ApiService.filterPostData("getfilterproductsdata" + "?page=" + currentPage, dataString,).then((res) => {
    if (res.status == "success") {
      if (sort !== null) {
        setProductsData(res.data.data)
      }
      else {
        if (res.data.data.length > 0) {
          const apires = res.data.data;
          const mergeData = [...resProductsData, ...apires];
          setProductsData(mergeData);
          // setTotalLength(res.data.total)
          // setLoading(false);
        } else {
          setLoading(false);
        }
      }
      setTotalLength(res.data.total);
      setLastNumber(res.data.last_page);
      setLoading(false);
      setLoadingMore(false);
      if (sort == null) {
        setCurrentNumber(currentPage + 1);
      }
    } else {
      setLoading(false);
      setLoadingMore(false);
    }
    
  });
}
   
    // }
  };

 
  return (
    <>
      {/* <Helmet>
        <title>{pageData.page_meta_title}</title>
        <meta name="description" itemprop="description" content={pageData.page_meta_desc != null ? pageData.page_meta_desc : "Ashna Vaswani"} />
        {pageData.page_meta_keyword != null ? <meta name="keywords" content={pageData.page_meta_keyword} /> : ""}
        <link rel="canonical" href={window.location.href} />
        <meta property="og:title" content={pageData.page_meta_title} />
        <meta name="twitter:url" content={window.location.href} />
        <meta property="og:image" content={constant.FRONT_URL + 'img/logo.png'} />
        <meta property="og:url" content={window.location.href} />
        <meta property="og:description" content={pageData.page_meta_desc != null ? pageData.page_meta_desc : "Ashna Vaswani"} />
        <meta name="twitter:title" content={pageData.page_meta_title} />
        <meta name="twitter:description" content={pageData.page_meta_desc != null ? pageData.page_meta_desc : "Ashna Vaswani"} />
        <meta property="twitter:image" content={constant.FRONT_URL + 'img/logo.png'} />
      </Helmet> */}
      <ToastContainer
        position="bottom-center"
        autoClose={2000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        draggable
        theme="light"
      />
      <BrowserView>
      <ProductCarasoulSchema productData={resProductsData} />
      
        <Header state="inner-header"  />
        <main>
          <div className="page-content mt-5 mb-5">
            <Container>
              <Row>
                <Productlistsidebar
                  sorting={sorting}
                  slug={slug}
                  type={"category"}
                  onFilteredData={handleFilteredData}
                  categoryName={handlecatName}
                  categoryImage={handlecatImage}
                  setscroll={setscrolldata}
                  showmodal={showFilter}

                />
                <Col lg={9}>
                  <Breadcrumb>
                    <Breadcrumb.Item href="/">Home</Breadcrumb.Item>
                    <Breadcrumb.Item active>All Products</Breadcrumb.Item>
                  </Breadcrumb>
                  <div className="page-title mb-2">
                    <h2 className="mb-0">All Products</h2>
                  </div>
                  <div className="filterselect" style={{ marginBottom: "10px" }}><div className="filterselectlist"><ul>
                    {localStorage.getItem('FILTER_SESSION') != null ?
                      Object.keys(JSON.parse(localStorage.getItem('FILTER_SESSION'))).map((key) => (
                        JSON.parse(localStorage.getItem('FILTER_SESSION'))[key].map((value) => (
                          <li>
                            {value}
                            <i className="fa fa-times" aria-hidden="true" onClick={() => { removefilterdata(key, value) }}></i></li>)))) : ""}</ul></div>
                    {filterData && localStorage.getItem('FILTER_SESSION') !== null && localStorage.getItem('FILTER_SESSION') !== undefined ?
                      filterData.collection && filterData.collection.length > 0 || filterData.category && filterData.category.length > 0 ?
                        <button className="resetbutton" onClick={resetFilter}>Reset Filter</button> : '' : ''}</div>
                  <div className="shortby">
                    <div className="productcount">
                      Showing results of {totalLength} products.
                    </div>

                    <div className="shortbydrop">
                      <div className="shortbydrop-inner select">
                        <label>Sort by</label>
                        <select
                          onChange={(e) => {getfilterproducts(e.target.value)}}
                        >
                          <option value="">Select</option>
                          <option value="featured" selected={sortingSession == "featured" ? true : ""}>Featured</option>
                          <option value="bestselling" selected={sortingSession == "bestselling" ? true : ""}>Best selling</option>
                          <option value="alphaasc" selected={sortingSession == "alphaasc" ? true : ""}>Alphabetically, A-Z</option>
                          <option value="alphadesc" selected={sortingSession == "alphadesc" ? true : ""}>Alphabetically, Z-A</option>
                          <option
                            value="asc"
                            selected={sortingSession == "asc" ? true : ""}
                          >
                            Price, low to high
                          </option>
                          <option
                            value="desc"
                            selected={sortingSession == "desc" ? true : ""}
                          >
                            Price, high to low
                          </option>
                          <option value="dateasc" selected={sortingSession == "dateasc" ? true : ""}>Date, old to new</option>
                          <option value="datedesc" selected={sortingSession == "datedesc" ? true : ""}>Date, new to old</option>
                        </select>
                      </div>
                    </div> 
                  </div>
                  <InfiniteScroll
                    dataLength={resProductsData.length}
                    next={getfilterproducts}
                    hasMore={true}
                    endMessage={<p>No more data to load.</p>}
                    style={{ overflow: "hidden !important" }}
                  >
                    {loading == true ? (
                      <Row>
                        {[...Array(9)].map((_, index) => (
                          <Col lg={4}>
                            <div className="product" key={index}>
                              <figure className="product-media">
                                <Skeleton
                                  variant="text"
                                  width={280}
                                  height={315}
                                />
                              </figure>
                              <div className="product-details text-center">
                                <h3 className="product-name">
                                  <Skeleton variant="text" width={150} />
                                </h3>
                                <div className="product-price">
                                  <Skeleton variant="text" width={150} />
                                </div>
                              </div>
                            </div>
                          </Col>
                        ))}
                      </Row>
                    ) : (
                      <>
                        {resProductsData.length > 0 ? (
                          <Row>
                            {resProductsData.map((value, indexProduct) => {
                              const productPrice = value.product_price;
                              const productSellingPrice =
                                value.product_selling_price;
                              const discount = (
                                ((productPrice - productSellingPrice) /
                                  productPrice) *
                                100
                              ).toFixed(0);
                              return (
                                <Col lg={4} key={indexProduct}>
                                  <div className="product">
                                    <figure className="product-media">
                                      <a
                                        href={
                                          "/product/" +
                                          value.product_slug
                                        }

                                      >
                                        <img
                                          src={
                                            value.product_image != null
                                              ? value.product_image
                                              : constant.DEFAULT_IMAGE
                                          }
                                          alt={value.product_name}
                                          width="280"
                                          height="315"
                                        />
                                        {value.gallery.length > 0 ? (
                                          <img
                                            src={
                                              value.gallery[0].gallery_image
                                                ? value.gallery[0].gallery_image
                                                : constant.DEFAULT_IMAGE
                                            }
                                            alt={value.product_name}
                                            width="280"
                                            height="315"
                                          />
                                        ) : null}
                                      </a>
                                      {/* {value.product_tag_name != "" ? (
                                        <div className="product-label-group">
                                          {value.product_tag_name
                                            .split(", ")
                                            .map((tagvalue, indextag) => {
                                              return (
                                                <label
                                                  className="product-label label-new"
                                                  key={indextag}
                                                >
                                                  {tagvalue}
                                                </label>
                                              );
                                            })}
                                        </div>
                                      ) : null} */}

                                      <div className="product-action-vertical">
                                        {setSession ? (
                                          value.ufp_id > 0 ? (
                                            <a
                                              href="javascript:void(0)"
                                              className="btn-product-icon btn-wishlist"
                                              title="Add to wishlists"
                                              onClick={(e) =>
                                                addtofav(value.product_id)
                                              }
                                            >
                                              <i
                                                className="d-icon-heart-full"
                                                id={
                                                  "wishlisticon" +
                                                  value.product_id
                                                }
                                              ></i>
                                            </a>
                                          ) : (
                                            <a
                                              href="javascript:void(0)"
                                              className="btn-product-icon btn-wishlist"
                                              title="Add to wishlist"
                                              onClick={(e) =>
                                                addtofav(value.product_id)
                                              }
                                            >
                                              <i
                                                className="d-icon-heart"
                                                id={
                                                  "wishlisticon" +
                                                  value.product_id
                                                }
                                              ></i>
                                            </a>
                                          )
                                        ) : (
                                          <a
                                            href="javascript:void(0)"
                                            className="btn-product-icon btn-wishlist"
                                            title="Add to wishlist"
                                            onClick={loginModal}
                                          >
                                            <i className="d-icon-heart"></i>
                                          </a>
                                        )}
                                      </div>

                                      <div className="product-action">
                                        <a
                                          href="javascript:void(0)"
                                          className="btn-product btn-quickview"
                                          title="Quick View"
                                          onClick={() => {
                                            handleShowQuickModal(value);
                                          }}
                                        >
                                          Quick View
                                        </a>
                                      </div>
                                    </figure>
                                    <div className="product-details">
                                      <div className="product-details-inner text-center">
                                        <h3 className="product-name">
                                          <a
                                            href={
                                              "/product/" +
                                              value.product_slug
                                            }
                                          >
                                            {value.product_name}
                                          </a>
                                        </h3>
                                        <div className="product-price">
                                          <ins className="new-price">
                                            {multiCurrency(value.product_selling_price)}

                                          </ins>
                                          {discount > 0 ? (
                                            <>
                                              <del className="old-price">
                                                {multiCurrency(value.product_price)}

                                              </del>
                                              <span className="off">
                                                {discount}% Off
                                              </span>
                                            </>
                                          ) : null}
                                        </div>
                                        {value.product_rating &&
                                          value.product_rating > 0 ? (
                                          <div className="ratings-container justify-content-center mb-0">
                                            <StarRating
                                              numberOfStars={value.product_rating}
                                            />
                                            <span>
                                              ( {value.product_review} reviews )
                                            </span>
                                          </div>
                                        ) : (
                                          ""
                                        )}
                                      </div> 
                                    </div>
                                  </div>
                                </Col>
                              );
                            })}
                          </Row>
                        ) : (
                          <h2>No More Products found.</h2>
                        )}
                      </>
                    )}
                  </InfiniteScroll>
                </Col>
              </Row>
            </Container>
          </div>
        </main>
        <Footer />
      </BrowserView>

      <MobileView>
        <ProductCarasoulSchema productData={resProductsData} />
        <MobileHeader
          PageName="All Products"
          
          
        />
        <main className="main">
          <div className="page-content mt-3 mb-5">
            <Container>

              <InfiniteScroll
                dataLength={resProductsData.length}
                next={getfilterproducts}
                hasMore={true}
                endMessage={<p>No more data to load.</p>}
                style={{ overflow: "hidden !important" }}
              >
                {loading == true ? (
                  <div className="row g-2">
                    {[...Array(9)].map((_, index) => (
                      <div className="col-6" key={index}>
                        <div className="product" key={index}>
                          <figure className="product-media">
                            <Skeleton
                              variant="text"
                              width={"100%"}
                              height={170}
                            />
                          </figure>
                          <div className="product-details">
                            <h3 className="product-name">
                              <Skeleton
                                variant="text"
                                width={"100%"}
                                height={10}
                              />
                            </h3>
                            <div className="product-price">
                              <Skeleton variant="text" width={100} height={5} />
                            </div>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <>
                    {resProductsData.length > 0 ? (
                      <div className="row g-2">
                        {resProductsData.map((value, indexProduct) => {
                          const productPrice = value.product_price;
                          const productSellingPrice =
                            value.product_selling_price;
                          const discount = (
                            ((productPrice - productSellingPrice) /
                              productPrice) *
                            100
                          ).toFixed(0);
                          return (
                            <div className="col-6" key={indexProduct}>
                              <div className="product">
                                <figure className="product-media">
                                  <a
                                    href={
                                      "/product/" + value.product_slug
                                    }

                                  >
                                    <img
                                      src={
                                        value.product_image != null
                                          ? value.product_image
                                          : constant.DEFAULT_IMAGE
                                      }
                                      alt={value.product_name}
                                      width="100%"
                                      height="170"
                                    />
                                    {value.gallery.length > 0 ? (
                                      <img
                                        src={
                                          value.gallery[0].gallery_image
                                            ? value.gallery[0].gallery_image
                                            : constant.DEFAULT_IMAGE
                                        }
                                        alt={value.product_name}
                                        width="100%"
                                        height="170"
                                      />
                                    ) : null}
                                  </a>
                                  {/* {value.product_tag_name != "" ? (
                                    <div className="product-label-group">
                                      {value.product_tag_name
                                        .split(", ")
                                        .map((tagvalue, indextag) => {
                                          return (
                                            <label
                                              className="product-label label-new"
                                              key={indextag}
                                            >
                                              {tagvalue}
                                            </label>
                                          );
                                        })}
                                    </div>
                                  ) : null} */}
                                  <div className="product-action-vertical">
                                    {setSession ? (
                                      value.ufp_id > 0 ? (
                                        <a
                                          href="javascript:void(0)"
                                          className="btn-product-icon btn-wishlist"
                                          title="Add to wishlists"
                                          onClick={(e) =>
                                            addtofav(value.product_id)
                                          }
                                        >
                                          <i
                                            className="d-icon-heart-full"
                                            id={
                                              "wishlisticon" + value.product_id
                                            }
                                          ></i>
                                        </a>
                                      ) : (
                                        <a
                                          href="javascript:void(0)"
                                          className="btn-product-icon btn-wishlist"
                                          title="Add to wishlist"
                                          onClick={(e) =>
                                            addtofav(value.product_id)
                                          }
                                        >
                                          <i
                                            className="d-icon-heart"
                                            id={
                                              "wishlisticon" + value.product_id
                                            }
                                          ></i>
                                        </a>
                                      )
                                    ) : (
                                      <a
                                        href="javascript:void(0)"
                                        className="btn-product-icon btn-wishlist"
                                        title="Add to wishlist"
                                        onClick={loginModal}
                                      >
                                        <i className="d-icon-heart"></i>
                                      </a>
                                    )}
                                  </div>

                                  <div className="product-action">
                                    <a
                                      href="javascript:void(0)"
                                      className="btn-product btn-quickview"
                                      title="Quick View"
                                      onClick={() => {
                                        handleShowQuickModal(value);
                                      }}
                                    >
                                      Quick View
                                    </a>
                                  </div>
                                </figure>
                                <div className="product-details">
                                  <div className="product-details-inner text-center">
                                    <h3 className="product-name">
                                      <a
                                        href={
                                          "/product/" + value.product_slug
                                        }
                                      >
                                        {value.product_name}
                                      </a>
                                    </h3>
                                    <div className="product-price">
                                      <ins className="new-price">
                                        {multiCurrency(value.product_selling_price)}

                                      </ins>
                                      {discount > 0 ? (
                                        <>
                                          <del className="old-price">
                                            {multiCurrency(value.product_price)}

                                          </del>
                                          <span className="off">
                                            {discount}% Off
                                          </span>
                                        </>
                                      ) : null}
                                    </div>
                                    {value.product_rating &&
                                      value.product_rating > 0 ? (
                                      <div className="ratings-container justify-content-center mb-0">
                                        <StarRating
                                          numberOfStars={value.product_rating}
                                        />
                                        <span>
                                          ( {value.product_review} reviews )
                                        </span>
                                      </div>
                                    ) : (
                                      ""
                                    )}
                                  </div> 
                                </div>
                              </div>
                            </div>
                          );
                        })}
                      </div>
                    ) : (
                      <h2>No More Products found.</h2>
                    )}
                  </>
                )}
              </InfiniteScroll>
            </Container>
            <div className="mfb-section">
              <div className="mfb-section-inner">
                <div
                  className="mfb-box border-right"
                  onClick={handleShowSortModal}
                >
                  <i className="d-icon-arrow-up"></i>
                  <i className="d-icon-arrow-down me-2"></i>Sort By
                </div>
                <div className="mfb-box" onClick={handleShowFilterModal}>
                  <i className="d-icon-filter-2 me-2"></i>Filter
                </div>
              </div>
            </div>
          </div>
        </main>
        <Productlistsidebar
          sorting={sorting}
          slug={slug}
          type={"category"}
          onFilteredData={handleFilteredData}
          categoryName={handlecatName}
          categoryImage={handlecatImage}
          setscroll={setscrolldata}
          showmodal={showFilter}
          HandleCloseModal={handleChildFilterModalData}
        />
      </MobileView>

      {showQuick && (
        <QuickViewModal
          showmodal={showQuick}
          productdata={productData}
          onChildData={handleChildQuickModalData}
        />
      )}
      {showSort && (
        <Modal show={showSort} onHide={handleClosesort} className="sortModal bottom">
          <div className="sortModalbox">
            <button onClick={handleClosesort} className="pop-close"><i className="d-icon-times"></i></button>
            <ul>
              <li onClick={(e) => { getfilterproducts('featured'); setShowSort(false); }}>
                <span>Featured</span>
                <input type="checkbox" value="featured" checked={sortingSession == 'featured' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('bestselling'); setShowSort(false); }}>
                <span>Best selling</span>
                <input type="checkbox" value="bestselling" checked={sortingSession == 'bestselling' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('alphaasc'); setShowSort(false); }}>
                <span>Alphabetically, A-Z</span>
                <input type="checkbox" value="alphaasc" checked={sortingSession == 'alphaasc' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('alphadesc'); setShowSort(false); }}>
                <span>Alphabetically, Z-A</span>
                <input type="checkbox" value="alphadesc" checked={sortingSession == 'alphadesc' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('asc'); setShowSort(false); }}>
                <span>Price, low to high</span>
                <input type="checkbox" value="asc" checked={sortingSession == 'asc' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('desc'); setShowSort(false); }}>
                <span>Price, high to low</span>
                <input type="checkbox" value="desc" checked={sortingSession == 'desc' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('dateasc'); setShowSort(false); }}>
                <span>Date, old to new</span>
                <input type="checkbox" value="dateasc" checked={sortingSession == 'dateasc' ? true : false} />
              </li>
              <li onClick={(e) => { getfilterproducts('datedesc'); setShowSort(false); }}>
                <span>Date, new to old</span>
                <input type="checkbox" value="datedesc" checked={sortingSession == 'datedesc' ? true : false} />
              </li>
            </ul>
          </div>
        </Modal>

      )}

      {showVariation && (
        <VariationModal
          showvariationmodal={showVariation}
          productdata={productData}
          onChildData={handleChildVariationModalData}
        />
      )}
    </>
  );
}
export default Productlist;
